import { ImageShape as ImageShapeSvg, ShapeType } from './image-shape-svg'

export enum ImageShapeSize {
  Small = 'small',
  Normal = 'normal',
  Full = 'full',
}

export interface ImageShapeType {
  shapeName?: ShapeType
  imageUrl?: string
  size: ImageShapeSize
  imagePos?: {
    x?: number
    y?: number
    scale?: number
  }
  ariaLabel: string
}

interface ImageShapeProps {
  content: ImageShapeType
}
export const ImageShape = (props: ImageShapeProps) => {
  return (
    <div style={{ color: 'white', height: '100%' }}>
      <ImageShapeSvg
        ariaLabel={props.content.ariaLabel}
        imgUrl={props.content.imageUrl || undefined}
        name={props.content.shapeName as ShapeType}
        imageOffset={{
          x: props.content.imagePos?.x || 0,
          y: props.content.imagePos?.y || 0,
          scale: props.content.imagePos?.scale || 1,
        }}
      />
    </div>
  )
}
